var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_11488500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.283 1.49994C8.26194 1.49994 5 4.76188 5 8.78292C5 11.4723 8.25327 17.0592 10.4134 20.4687C11.281 21.8437 13.2893 21.8437 14.1569 20.4687C16.317 17.0592 19.5703 11.4679 19.5703 8.78292C19.566 4.76188 16.3084 1.49994 12.283 1.49994ZM12.283 13.2204C9.83652 13.2204 7.84986 11.2337 7.84986 8.78726C7.84986 6.3408 9.83652 4.3498 12.283 4.3498C14.7294 4.3498 16.7161 6.33646 16.7161 8.78292C16.7161 11.2294 14.7338 13.2204 12.283 13.2204ZM14.4995 8.78726C14.4995 10.0105 13.5062 11.0038 12.283 11.0038C11.0598 11.0038 10.0664 10.0105 10.0664 8.78726C10.0664 7.56403 11.0598 6.5707 12.283 6.5707C13.5062 6.5707 14.4995 7.55969 14.4995 8.78726Z",
    fill: "#686868"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.edbbf46aa5814d304a0731d4402d2a3f.svg";
export { ForwardRef as ReactComponent };